// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchTheme_container__2xaBP","switchTheme":"SwitchTheme_switchTheme__3IXsE","moon":"SwitchTheme_moon__2ZgC5","sun":"SwitchTheme_sun__2sZn9"};